import { rootPath, getToken } from '../../utils/apiConfig';

export const downloadTransactions = (payload: any, url: Function) => {
  const params: Array<string> = [];
  payload &&
    Object.keys(payload).length &&
    Object.keys(payload).forEach((key: string) => params.push(`${[key]}=${payload[key]}`));
  downloadVehicleTransactions(url(params.join('&')));
};

export const downloadVehicleTransactions = (downloadUrl: any) => {
  const token = getToken();
  let url = `${rootPath}/${downloadUrl}`;
  if (token) {
    if (url.includes('?')) {
      url += `&token=${token}`;
    } else {
      url += `?token=${token}`;
    }
  }
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.className = 'hide';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
